<template>
  <main>
    <h1 class="d-flex">
      <v-icon v-if="isEdit" class="teams-icon" color="success" medium
        >mdi-pencil</v-icon
      >
      <v-icon
        v-else
        class="teams-icon icon-user"
        color="success"
        medium
      ></v-icon>
      <span v-if="isEdit">Edit Child</span>
      <span v-else>New Child</span>
      <v-btn
        @click="openCard = true"
        color="primary"
        outlined
        large
        class="ml-auto"
        ><strong>Wellspring Card</strong></v-btn
      >
    </h1>
    <v-row>
      <v-col lg="10" class="mx-auto">
        <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
          <p
            class="mb-0"
            v-for="globalErr in globalServerErrors"
            :key="globalErr"
          >
            {{ globalErr[0] }}
          </p>
        </v-alert>
        <formWrapper :validator="$v.form">
          <form @submit.prevent="handleSave" class="form-box">
            <v-row>
              <v-col
                v-if="isEdit && profileBoolean"
                cols="6"
                sm="2"
                class="align-self-center"
              >
                <v-avatar size="120" class="elevation-7">
                  <v-img :src="form.photo_url" />
                </v-avatar>
              </v-col>
              <v-col
                v-if="!isEdit && profileBoolean"
                cols="6"
                sm="2"
                class="align-self-center"
              >
                <p class="mb-0">Profile Picture</p>
              </v-col>
              <v-col cols="6" sm="10">
                <v-row>
                  <v-col cols="12" sm="3" class="align-self-center">
                    <section class="file-upload">
                      <new-image-upload
                        class="file-upload__image"
                        :imgUrl="
                          form.profile_photo ? form.profile_photo.path : ''
                        "
                        :imgId="form.profile_photo ? form.profile_photo.id : ''"
                        @fileSelected="profileChange"
                        fieldName="mainImgFile"
                        :maxSize="maxSize"
                        :reset="reset"
                      />
                    </section>
                  </v-col>
                  <v-col v-if="isEdit" cols="12" sm="3">
                    <section class="transparent-field">
                      <v-switch
                        v-model="form.card_issued"
                        inset
                        false-value="0"
                        true-value="1"
                        label="Card Issued"
                        color="success"
                      ></v-switch>
                    </section>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <section class="transparent-field">
                      <v-switch
                        v-model="form.is_reg_fees_paid"
                        inset
                        :false-value="0"
                        :true-value="1"
                        label="Reg Fees Paid"
                        color="success"
                      ></v-switch>
                    </section>
                  </v-col>
                  <v-col v-if="isEdit" cols="12" sm="3">
                    <section class="transparent-field">
                      <v-switch
                        v-model="form.is_insured"
                        inset
                        false-value="0"
                        true-value="1"
                        label="Insured"
                        color="success"
                      ></v-switch>
                    </section>
                  </v-col>
                </v-row>
              </v-col>
              <v-col class="py-0 mt-sm-6" cols="12" sm="4">
                <form-group name="first_name" :attribute="`fields.first_name`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.first_name"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0 mt-sm-6" cols="12" sm="4">
                <form-group
                  name="middle_name"
                  :attribute="`fields.middle_name`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.middle_name"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0 mt-sm-6" cols="12" sm="4">
                <form-group name="last_name" :attribute="`fields.last_name`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.last_name"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group name="school" attribute="fields.school">
                  <template slot-scope="{ attrs, listeners }">
                    <v-autocomplete
                      :loading="loadingData"
                      :items="schools"
                      item-text="name"
                      item-value="id"
                      regular
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.school.id"
                    ></v-autocomplete>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group
                  name="school_name"
                  :attribute="`fields.school_name`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.school_name"
                      :disabled="form.school.id !== 9999"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group name="clothes_size" attribute="fields.clothes_size">
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :loading="loadingData"
                      :items="clothes"
                      item-text="name"
                      item-value="id"
                      regular
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.clothes_size.id"
                    ></v-select>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group name="grade" attribute="fields.grade">
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :loading="loadingData"
                      :items="grades"
                      item-text="name"
                      item-value="id"
                      regular
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.grade.id"
                    ></v-select>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0 dates" cols="12" sm="6">
                <v-dialog
                  ref="birthdateDialog"
                  v-model="birth_date_modal"
                  :return-value.sync="form.birth_date.date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="form.birth_date.date"
                      label="Birthdate"
                      readonly
                      clearable
                      v-on="on"
                      append-icon="icon-calendar"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.birth_date.date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="birth_date_modal = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.birthdateDialog.save(form.birth_date.date)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <form-group name="gender" attribute="fields.gender">
                  <template slot-scope="{ attrs, listeners }">
                    <v-select
                      :loading="loadingData"
                      :items="genders"
                      item-text="name"
                      item-value="id"
                      regular
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.gender.id"
                    ></v-select>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12">
                <form-group
                  name="national_id"
                  :attribute="`fields.national_id`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.national_id"
                      type="text"
                      hint="We cannot apply the PA (personal accident) insurance if you submit a wrong ID number"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>

              <v-col class="py-0" cols="12" sm="12">
                <form-group
                  name="medical_comments"
                  :attribute="`fields.medical_comments`"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-textarea
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.medical_comments"
                    ></v-textarea>
                  </template>
                </form-group>
              </v-col>
              <v-col class="py-0" cols="12" sm="12">
                <form-group name="memo" :attribute="`fields.memo`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-textarea
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.memo"
                    ></v-textarea>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12" md="4" class="align-self-center">
                <p class="mb-0">Change photo Birth Certificate ID</p>
                <!-- <span>{{ $t("labels.Image_icon") }}</span> -->
              </v-col>
              <v-col cols="12" md="8">
                <section class="file-upload">
                  <new-image-upload
                    class="file-upload__image"
                    :imgUrl="
                      form.birth_certificate ? form.birth_certificate.path : ''
                    "
                    :imgId="
                      form.birth_certificate ? form.birth_certificate.id : ''
                    "
                    @fileSelected="imageChange"
                    fieldName="mainImgFile"
                    :maxSize="maxSize"
                    :reset="reset"
                  />
                  <a
                    :href="form.birth_certificate_url"
                    target="_blank"
                    v-if="isEdit === true && changeEditBoolean"
                    class="mt-3"
                  >
                    show image
                  </a>
                  <!-- @ImageUpdated="hanleRefreshTable" -->
                </section>
              </v-col>
              <v-col cols="12">
                <v-btn
                  class="success text-capitalize"
                  large
                  type="submit"
                  width="30%"
                  :disabled="!isEdit && $v.form.$invalid"
                  :loading="loadingSave"
                >
                  <span>Save</span></v-btn
                >
                <v-btn text large color="primary" class="ml-2" @click="back"
                  >Cancel</v-btn
                >
              </v-col>
            </v-row>
          </form>
        </formWrapper>
      </v-col>
    </v-row>
    <v-row v-if="isEdit === true">
      <v-col lg="10" class="mx-auto">
        <v-row>
          <v-col sm="10">
            <article>
              <h2>Block Camper</h2>
              <p>Block this Camper for all camps</p>
            </article>
          </v-col>
          <v-col sm="2" class="align-self-center">
            <v-btn
              @click="blockCamper"
              outlined
              color="error"
              large
              width="100%"
              ><span v-if="is_blocked == 0">Block</span
              ><span v-else>Unblock</span></v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-dialog v-model="openCard" width="325px">
      <v-card class="card-height radius-12" width="325px" id="cardPrint">
        <section>
          <article class="child-card">
            <h4 class="mt-2 child-card__name">
              {{ form.full_name }}
            </h4>
            <p>
              <strong>{{ form.wellspring_id }}</strong>
            </p>
          </article>
          <v-avatar size="100">
            <v-img
              v-if="form.photo_url != null"
              :src="form ? form.photo_url : '--'"
            ></v-img>
          </v-avatar>
        </section>
        <v-btn
          class="print"
          id="printed"
          @click="print"
          :disabled="form.is_reg_fees_paid == 0"
          >Print</v-btn
        >
      </v-card>
    </v-dialog>
  </main>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  numeric
} from "vuelidate/lib/validators";
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData
} from "@/helpers/apiMethods";
export default {
  data() {
    return {
      form: {
        account: this.$route.query.account,
        first_name: "",
        middle_name: "",
        last_name: "",
        school: {
          id: "",
          name: ""
        },
        school_name: "",
        clothes_size: {
          id: "",
          name: ""
        },
        grade: {
          id: "",
          name: ""
        },
        gender: {
          id: "",
          name: ""
        },
        birth_date: { date: "" },
        national_id: "",
        medical_comments: "",
        memo: ""
      },
      birth_date_modal: false,
      schools: [],
      clothes: [],
      grades: [],
      genders: [
        { id: 0, name: "Male" },
        { id: 1, name: "Female" }
      ],
      maxSize: 2.048,
      reset: false,
      loadingData: false,
      isEdit: false,
      changeEditBoolean: true,
      profileBoolean: true,
      loadingSave: false,
      is_blocked: 1,
      globalServerErrors: null,
      openCard: false
    };
  },
  created() {
    this.indexSchools();
    this.indexClothesSizes();
    this.indexGrades();
    this.editCreateBoolean();
    if (this.isEdit === true) {
      this.handleParentData();
    }
  },
  methods: {
    indexSchools() {
      IndexData({ reqName: `/schools` })
        .then(res => {
          const { data } = res.data;
          this.schools = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexClothesSizes() {
      IndexData({ reqName: `/clothes-sizes` })
        .then(res => {
          const { data } = res.data;
          this.clothes = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexGrades() {
      IndexData({ reqName: `/grades` })
        .then(res => {
          const { data } = res.data;
          this.grades = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleSave() {
      this.$route.params.id ? this.editChild() : this.addChild();
    },
    addChild() {
      const formData = new FormData();
      const dateFormat = "YYYY-MM-DD";
      this.form.birth_date = {
        date: this.$moment(this.form.birth_date.date).format(dateFormat)
      };

      Object.keys(this.form).forEach(formItem => {
        if (
          formItem === "school" ||
          formItem === "clothes_size" ||
          formItem === "grade" ||
          formItem === "gender"
        ) {
          formData.append(formItem, this.form[formItem].id);
        } else if (formItem === null) {
          return "";
        } else if (formItem === "birth_date") {
          formData.append(formItem, this.form[formItem].date);
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      StoreData({
        reqName: `children`,
        data: formData
      })
        .then(() => {
          history.go(-1);
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editChild() {
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        if (
          formItem === "full_name" ||
          formItem === "parent" ||
          formItem === "email" ||
          formItem === "photo_url" ||
          formItem === "birth_certificate_url" ||
          formItem === "payment_method" ||
          formItem === "is_blocked" ||
          formItem === "has_complete_profile" ||
          formItem === "status" ||
          formItem === null
        ) {
          return;
        }
        if (
          formItem === "school" ||
          formItem === "clothes_size" ||
          formItem === "grade" ||
          formItem === "gender"
        ) {
          formData.append(formItem, this.form[formItem].id);
        } else if (formItem === "birth_date") {
          formData.append(formItem, this.form[formItem].date);
        } else {
          formData.append(formItem, this.form[formItem]);
        }
      });
      formData.append("_method", "put");

      UpdateData({
        reqName: `children`,
        data: formData,
        id: this.$route.params.id
      })
        .then(() => {
          history.go(-1);
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    handleParentData() {
      ShowData({
        reqName: "children",
        id: this.$route.params.id
      })
        .then(res => {
          const { child } = res.data;
          this.form = { ...child };
          if (child.birth_date === null) {
            this.form.birth_date = { date: "" };
          }
          if (child.birth_date !== null) {
            this.form.birth_date = {
              date: this.$moment(this.form.birth_date.date).format("YYYY-MM-DD")
            };
          }
          if (child.clothes_size === null) {
            this.form.clothes_size = { id: "" };
          }
          if (child.gender === 0) {
            this.form.gender = { id: 0, name: "Male" };
          } else {
            this.form.gender = { id: 1, name: "Female" };
          }
          if (child.card_issued === 0) {
            this.form.card_issued = "0";
          } else {
            this.form.card_issued = "1";
          }
          if (child.is_insured === 0) {
            this.form.is_insured = "0";
          } else {
            this.form.is_insured = "1";
          }
          if (child.is_blocked === 1) {
            this.is_blocked = 1;
          } else {
            this.is_blocked = 0;
          }
          if (child.medical_comments == null) {
            this.form.medical_comments = "";
          }
          if (child.memo == null) {
            this.form.memo = "";
          }
          if (child.last_name == null) {
            this.form.last_name = "";
          }
        })
        .catch(() => {});
    },
    back() {
      history.go(-1);
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
    },
    imageChange(photo) {
      this.form.birth_certificate = photo.file;
      this.reset = false;
      this.changeEditBoolean = false;
    },
    profileChange(photo) {
      this.form.profile_photo = photo.file;
      this.reset = false;
      this.profileBoolean = false;
    },
    blockCamper() {
      this.popUp().then(value => {
        if (!value.dismiss) {
          UpdateData({
            reqName: `children`,
            data: { block: !this.is_blocked, _method: "put" },
            id: this.$route.params.id
          })
            .then(() => {
              history.go(-1);
              // this.is_blocked = this.form.is_blocked;
            })
            .catch(() => {})
            .finally(() => {});
        }
      });
    },
    print() {
      window.print(this.form);
    }
  },
  validations: {
    form: {
      first_name: {
        required,
        minLength: minLength(3)
      },
      middle_name: {
        required,
        minLength: minLength(3)
      },
      last_name: {
        required,
        minLength: minLength(3)
      },
      school: {
        required
      },
      clothes_size: {
        required
      },
      national_id: {
        required,
        minLength: minLength(14),
        maxLength: maxLength(14),
        numeric
      },
      medical_comments: {
        minLength: minLength(3)
      },
      memo: {
        minLength: minLength(3)
      }
    }
  }
};
</script>
<style lang="scss">
@media print {
  html,
  body {
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden;
  }

  #printed {
    display: none !important;
  }
}

// .child-card {
//   &__name {
//     font-size: 15px;
//   }
// }
</style>
